define('src/queue/promise-queue',[
    'jquery', 'backbone', 'underscore', 'utils'
], function($, Backbone, _, U) {

    var PromiseQueue = function(callback, context) {
        _.extend(this, {
            promises: [],
            context: context,
            callback: callback,
        });
    };

    _.extend(PromiseQueue.prototype, Backbone.Events, {
        push: function(promise) {
            if (!this.hasPromise(promise)) {
                this.promises.push(promise);
                promise.always(function() {
                    if (!this.promises.length) return; // queue has been reset
                    this.promises = _.without(this.promises, promise);
                    this.trigger('progress', promise);
                    if (!this.promises.length) this._onComplete();
                }.bind(this));

            }
            return this;
        },
        _onComplete: function() {
            this.promises = [];
            _.callback(this.context, this.callback);
            this.trigger('complete');
        },

        hasPromise: function(promise) {
            return this.promises.indexOf(promise) >= 0;
        },
        count: function() {
            return this.promises.length;
        },
        reset: function() {
            this.promises = [];
        }
    });

    return PromiseQueue;

});

